// src/admin/pages/KPI/components/kpi/KPICard.js
import React from "react";

/**
 * Card KPI con supporto al click (facoltativo)
 *
 * Props:
 *  - title        (string)  → etichetta KPI
 *  - value        (string)  → valore formattato da mostrare
 *  - description? (string)  → sottotitolo
 *  - onClick?     (func)    → handler; se presente la card diventa cliccabile
 */
export default function KPICard({ title, value, description, onClick }) {
  const clickable = typeof onClick === "function";

  return (
    <div
      style={{
        ...styles.card,
        cursor: clickable ? "pointer" : "default",
      }}
      onClick={clickable ? onClick : undefined}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={(e) =>
        clickable && (e.key === "Enter" || e.key === " ") && onClick()
      }
    >
      <div style={styles.sideAccent} />
      <h3 style={styles.title}>{title}</h3>
      <p style={styles.value}>{value}</p>
      {description && <p style={styles.desc}>{description}</p>}
    </div>
  );
}

/* ---------------- Stili ---------------- */
const styles = {
  card: {
    position: "relative",
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "1rem",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    textAlign: "center",
    overflow: "hidden",
    transition: "transform 0.15s ease", // lieve feedback al hover
  },
  sideAccent: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: "6px",
    backgroundColor: "#336699",
    borderTopLeftRadius: "10px",
    borderBottomLeftRadius: "10px",
  },
  title: {
    margin: 0,
    marginBottom: "0.4rem",
    color: "#FF6600", // primario
    fontSize: "1.1rem",
    fontWeight: 600,
  },
  value: {
    margin: 0,
    marginBottom: "0.5rem",
    fontSize: "1.4rem",
    fontWeight: "bold",
    color: "#336699", // secondario
  },
  desc: {
    margin: 0,
    marginTop: "0.25rem",
    fontSize: "0.85rem",
    color: "#555",
  },
};
